import * as React from "react";
const SvgMobileMenuIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 14, viewBox: "0 0 20 14", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 13.333v-2.222h20v2.222zm0-5.555V5.556h20v2.222zm0-5.556V0h20v2.222z" }));
export default SvgMobileMenuIcon;
